export const Hr = ({ color }) => {
  return <hr style={{ backgroundColor: color || '' }} />
}
